import { create } from 'apisauce'

const api = create({
    baseURL: 'https://vm1-braconi.braconi.com.br/'
})


api.addAsyncRequestTransform(response => async() =>{
    
    const token = localStorage.getItem('@USER_TOKEN_FACTORY')
    
    if(token){

        response.headers['Authorization']  = `Bearer ${token}`

    }

})

export default api